import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { SettingsNav } from "./-components/settings-nav";

export const Route = createFileRoute("/(app)/settings")({
	component: RouteComponent,
	beforeLoad: async ({ context, location }) => {
		const user = context.user;

		if (!user || user.isAnonymous) {
			throw redirect({ to: "/sign-in" });
		}

		if (location.pathname === "/settings" || location.pathname === "/settings/") {
			throw redirect({ to: "/settings/user" });
		}
	},
});

function RouteComponent() {
	return (
		<div className="flex flex-col md:flex-row gap-6 md:gap-8 w-full py-6 px-4">
			<SettingsNav />
			<div className="flex-1 min-w-0">
				<Outlet />
			</div>
		</div>
	);
}
